import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Header, Loader, Message, Segment } from "semantic-ui-react";
import ForgotPassword from "./ForgotPassword";
import { authUser, forgotPwd } from "services/auth";
import Form from "./components/Form";
import { Redirect } from "react-router-dom";
import { isMobile } from "utils/isMobile";
import nurseImage from "../../assets/image/nurseImage.jpg";
import { Slide, toast, ToastContainer } from "react-toastify";

class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			redirect: false,
			forgotpwd: false,
		};
	}

	componentDidMount() {}

	submitAuth = async (values) => {
		await this.props.authUser(values);
	};

	submitEmail = async (mail) => {
		this.props.forgotPwd(mail);
		this.setState({ forgotpwd: false });
	};

	render() {
		const { user } = this.props;

		if (this.props.user.session.token !== null && this.props.user.session.id !== null) {
			return <Redirect to="/home" />;
		}

		return (
			<Segment.Group horizontal style={{ height: "100vh", display: "flex", margin: 0 }}>
				{!isMobile() && (
					<Segment
						placeholder
						style={{ backgroundImage: `url(${nurseImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", padding: "15px" }}
					></Segment>
				)}
				<Segment placeholder>
					<Grid stackable textAlign="center" className="align-items-stretch h-100">
						<Grid.Row verticalAlign="middle">
							<Grid.Column mobile={7} desktop={7} textAlign="center">
								<div className="mt-4">
									<h1 style={{ fontSize: 35 }}> MyLabNurse</h1>
									<p>Veuillez vous authentifier</p>
									{this.state.forgotpwd ? (
										<>
											<ForgotPassword submitEmail={this.submitEmail} />
											<div
												onClick={() => this.setState({ forgotpwd: false })}
												style={{ textAlign: "right", width: "100%", cursor: "pointer", textDecoration: "underline" }}
											>
												Se connecter ?
											</div>
										</>
									) : (
										<>
											<Form submitAuth={this.submitAuth} />
											{user.loading && (
												<div style={styles.blocWhiteError}>
													<Loader inline active size="tiny" />
												</div>
											)}
											<div
												onClick={() => this.setState({ forgotpwd: true })}
												style={{ textAlign: "right", width: "100%", cursor: "pointer", textDecoration: "underline" }}
											>
												Mot de passe oublié ?
											</div>
											{user.error && <Message error>{user.error}</Message>}
										</>
									)}
								</div>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Segment>
				<ToastContainer position="bottom-left" autoClose={10000} hideProgressBar={true} transition={Slide} />
			</Segment.Group>
			// </Grid>
		);
	}
}

const styles = {
	blocWhiteLogin: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
	},
	blocWhiteError: {
		backgroundColor: "#fff",
		padding: 10,
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		user: state.user,
	};
};

const mapDispatchToProps = {
	authUser,
	forgotPwd,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
